import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { RequestSummaryComponent } from '../../components/request-summary/request-summary.component';
import { RequestDto } from '../../models/request.dto';
import { NgxPrintService } from 'ngx-print';

@Component({
  selector: 'app-print',
  standalone: true,
  imports: [CommonModule, RequestSummaryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './print.component.html',
  styleUrl: './print.component.scss',
})
export class PrintComponent {
  @ViewChild('fr') formRenderer!: ElementRef;

  formMetaData: any;
  request: RequestDto | undefined;
  ehrServerUrl: string | undefined;
  credentials: any;
  context: any;
  compositionId: string | undefined;
  formEnvironment: any;
  returnUrl: string | undefined;

  constructor(private router: Router, private printService: NgxPrintService) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state;

    if (state) {
      this.formMetaData = state['formMetaData'];
      this.compositionId = state['compositionId'];
      this.credentials = state['credentials'];
      this.ehrServerUrl = state['ehrServerUrl'];
      this.formEnvironment = state['environment'];

      this.context = {
        ...state?.['context'],
        readonly: true,
        presentationMode: true,
        disableScriptRunOnInitialization: true,
      };
      this.returnUrl = state['returnUrl'] || '/';
      this.request = state['request'];
    }
  }

  formRendered($event: any) {
  const scriptApi = this.formRenderer?.nativeElement.getScriptApi();
  if (scriptApi) {
    setTimeout(() => {
      this.printService.print({
        printSectionId: 'print-section',
        useExistingCss: true, 
        printTitle: 'Stampa',
        bodyClass: '',
        openNewTab: true,
        previewOnly: false,
        closeWindow: true,
        printDelay: 0
      });

      setTimeout(() => {
        this.router.navigateByUrl(this.returnUrl || '/');
      }, 1000);
    }, 500);
  }
}

  // formRendered($event: any) {
  //   console.log($event);
  //   const scriptApi = this.formRenderer?.nativeElement.getScriptApi();
  //   if (scriptApi) {
  //     setTimeout(() => {
  //       window.print();

  //       setTimeout(() => {
  //         this.router.navigateByUrl(this.returnUrl || '/');
  //       }, 1000);
  //     }, 500);
  //   }
  // }
}
